var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type!=='static')?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.hideOnClick",modifiers:{"hideOnClick":true}}],staticClass:"fragment-text",class:_vm.classes,attrs:{"title":_vm.type}},[_vm._v(_vm._s(_vm.text))]):_c('span',{staticClass:"fragment-text",class:_vm.classes},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }